import { useIsOnlyOneAssistant } from './isOnlyOneAssistant';
import { useGetPermission } from './useNewPermisson';
import useRoles from './useRoles';

const useIsAdminViewWithMultiAssist = () => {
  const isOnlyAssistant = useIsOnlyOneAssistant();
  const getPermission = useGetPermission();
  const { isSuperviser } = useRoles();
  const isAdminViewWithMultiAssist = getPermission('管理员视角', {
    fallbackPermission: isSuperviser && !isOnlyAssistant,
  });
  return isAdminViewWithMultiAssist;
};

export default useIsAdminViewWithMultiAssist;
